"use strict";

var _slicedToArray = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Arrow = (0, _helpers.getImageByAgent)('left-arrow-orange.svg');
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    overflow: {
      '& .btn': {
        '& img': {
          marginRight: 7
        },
        backgroundColor: 'transparent',
        boxShadow: 'unset',
        color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
        fontSize: theme.typography.pxToRem(13),
        fontWeight: 700,
        padding: '8px 10px'
      },
      '&.hide': {
        opacity: 0
      },
      alignItems: 'flex-end',
      background: theme.palette.type === 'light' ? 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 20%, rgba(0,0,0,0) 100%)' : 'linear-gradient(0deg, rgba(66,66,66,1) 0%, rgba(66,66,66,1) 20%, rgba(255,255,255,0) 100%)',
      bottom: 0,
      display: 'flex',
      flexDirection: 'row',
      height: 200,
      position: 'absolute',
      transition: '0.3s all',
      width: '100%'
    },
    root: {
      position: 'relative'
    },
    showMore: {
      maxHeight: 290,
      transition: '0.5s ease-out'
    },
    table: {
      '& .MuiTableCell-root': {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1,
        padding: 15
      },
      '& .MuiTableCell-root.title': {
        borderRight: '1px solid #D8EAF1',
        color: theme.palette.secondary.dark,
        direction: 'rtl',
        fontWeight: 600,
        paddingLeft: 'unset'
      },
      '& .MuiTableRow-root:last-child .MuiTableCell-root': {
        borderBottom: 'unset'
      },
      display: 'block',
      maxHeight: 1000,
      overflow: 'hidden',
      transition: 'max-height 0.25s ease-in'
    }
  };
});
var SimpleTable = function SimpleTable(_ref) {
  var items = _ref.items,
    className = _ref.className,
    showMore = _ref.showMore;
  var classes = useStyles();
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    isShowingAll = _react$default$useSta2[0],
    setIsShowingAll = _react$default$useSta2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: "".concat(classes.table, " ").concat(className, " ").concat(showMore && !isShowingAll ? classes.showMore : ''),
    "aria-label": "simple table"
  }, /*#__PURE__*/_react.default.createElement(_core.TableBody, null, items.length ? items.map(function (_ref2, index) {
    var title = _ref2.title,
      value = _ref2.value;
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: "row-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      className: 'title'
    }, title), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, value));
  }) : false)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.overflow, " ").concat(isShowingAll || !showMore ? 'hide' : '')
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: 'btn',
    onClick: function onClick() {
      return setIsShowingAll(!isShowingAll);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: Arrow,
    alt: 'arrow-down'
  }), "\u05D4\u05E8\u05D0\u05D4 \u05E2\u05D5\u05D3")));
};
SimpleTable.propTypes = {
  className: _propTypes.default.string,
  items: _propTypes.default.array,
  showMore: _propTypes.default.bool
};
var _default = exports.default = SimpleTable;